import { PaymentFlowContext, PaymentFlowResult } from '@/Services/PaymentMethod/types';
import * as Sentry from '@sentry/vue';
import { confirmSetup, processSetupIntentConfirmation } from '@/Services/PaymentMethod/processPayment';

export default async function processWalletPayment(context: PaymentFlowContext): Promise<PaymentFlowResult> {
  try {
    // For wallet payments (Google Pay, Apple Pay), we need to call confirmSetup FIRST
    // to preserve the transient user activation required by the browser.
    // Backend operations happen after in processSetupIntentConfirmation.
    const { error, setupIntent } = await confirmSetup(context);

    return await processSetupIntentConfirmation(context, setupIntent, error, 'wallet');
  } catch (error: any) {
    Sentry.captureException(error);
    return {
      success: false,
      error: {
        message_key: 'checkout.checkout_errors.unexpected_payment_processing_error',
        container: 'payment-element-container',
        error_code: 'ERR-103',
      },
    };
  }
}
